import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
/*
 * @Author: your name
 * @Date: 2020-08-22 15:58:11
 * @LastEditTime: 2020-08-22 16:00:23
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/directive.js
 */
import Vue from 'vue';
// 只能输入正整数  0-9的数字
Vue.directive('enterIntNumber', {
  inserted: function inserted(el) {
    var trigger = function trigger(el, type) {
      var e = document.createEvent('HTMLEvents');
      e.initEvent(type, true, true);
      el.dispatchEvent(e);
    };
    el.addEventListener('keyup', function (e) {
      var input = e.target;
      var reg = new RegExp('^\\d{1}\\d*$'); // 正则验证是否是数字
      var correctReg = new RegExp('\\d{1}\\d*'); // 正则获取是数字的部分
      var matchRes = input.value.match(reg);
      if (matchRes === null) {
        // 若不是纯数字 把纯数字部分用正则获取出来替换掉
        var correctMatchRes = input.value.match(correctReg);
        if (correctMatchRes) {
          input.value = correctMatchRes[0];
        } else {
          input.value = '';
        }
      }
      trigger(input, 'input');
    });
  }
});

// 只能输入一位小数
Vue.directive('enterNumberPoint1', {
  inserted: function inserted(el) {
    var trigger = function trigger(el, type) {
      var e = document.createEvent('HTMLEvents');
      e.initEvent(type, true, true);
      el.dispatchEvent(e);
    };
    el.addEventListener('keyup', function (e) {
      var input = e.target;
      var reg = new RegExp('^((?:(?:[1-9]{1}\\d*)|(?:[0]{1}))(?:\\.(?:\\d){0,1})?)(?:\\d*)?$'); // 正则验证是否是数字(小数整数均可)
      var matchRes = input.value.match(reg);
      if (matchRes === null) {
        input.value = '';
      } else {
        // matchRes[0]是匹配的无限位的小数
        // matchRes[1]是小数点后两位前面符合的数值
        // 如输入12.223 matchRes[0]是12.223 matchRes[1]12.22 此时input值改为matchRes[1]的值即可
        if (matchRes[1] !== matchRes[0]) {
          input.value = matchRes[1];
        }
      }
      trigger(input, 'input');
    });
  }
});

// 只能输入两位小数
Vue.directive('enterNumberPoint2', {
  inserted: function inserted(el) {
    var trigger = function trigger(el, type) {
      var e = document.createEvent('HTMLEvents');
      e.initEvent(type, true, true);
      el.dispatchEvent(e);
    };
    el.addEventListener('keyup', function (e) {
      var input = e.target;
      var reg = new RegExp('^((?:(?:[1-9]{1}\\d*)|(?:[0]{1}))(?:\\.(?:\\d){0,2})?)(?:\\d*)?$'); // 正则验证是否是数字(小数整数均可)
      var matchRes = input.value.match(reg);
      if (matchRes === null) {
        input.value = '';
      } else {
        // matchRes[0]是匹配的无限位的小数
        // matchRes[1]是小数点后两位前面符合的数值
        // 如输入12.223 matchRes[0]是12.223 matchRes[1]12.22 此时input值改为matchRes[1]的值即可
        if (matchRes[1] !== matchRes[0]) {
          input.value = matchRes[1];
        }
      }
      trigger(input, 'input');
    });
  }
});

// 输入数字限制最大值
Vue.directive('enterNumberMax', {
  inserted: function inserted(el, binding) {
    // binding.value
    var trigger = function trigger(el, type) {
      var e = document.createEvent('HTMLEvents');
      e.initEvent(type, true, true);
      el.dispatchEvent(e);
    };
    el.addEventListener('keyup', function (e) {
      var input = e.target;
      var value = input.value;
      if (parseFloat(value) > parseFloat(binding.value)) {
        input.value = binding.value;
      }
      trigger(input, 'input');
    });
  }
});